// generated by genversion
export var version = '4.5.7';
//# sourceMappingURL=version.js.map